module.exports = __webpack_public_path__ + "static/media/admin.f482eca3.svg";